import Logo from './../../assets/img/svg/logo.svg';
import AboutImage from './../../assets/img/about.png';
import ArtCommerce from './../../assets/img/art-commerce.svg';
import { withRouter } from 'react-router-dom';
import LeftArrow from './../../assets/img/left-arrow.png';
import RightArrow from './../../assets/img/right-arrow.png';
import GetStart from './../../assets/img/getting-started.png';
import BlockChainImage from './../../assets/img/blockchain.png';
import ArtistImage from './../../assets/img/banner-1.png'
import MusicianImage from './../../assets/img/banner-2.png'
import InvestorImage from './../../assets/img/banner-3.png'

import React, { Suspense, useEffect, useState, Fragment } from 'react'
import ReactPlayer from 'react-player'
import Slider from "react-slick"
import Ecommerce from "./Ecommerce"
import CreatorInvestor from './CreatorInvestor'
import AboutAndWhy from './AboutAndWhy'
import GettingStarted from './GettingStarted'
import RangeCheck from './RangeCheck'
import Loader from '../loader/Loader';
import { VideoGuideAPi } from './../../container/Api/api'
import { connect } from 'react-redux';
import { selectedUserType } from './../../store/actions/userAction'
import { fetchBannerImagesData } from './../../store/actions/siteAction'
import { useMediaQuery } from 'react-responsive'
const MostWatchedSlide = React.lazy(() => import('./MostWatchedSlide'));
// const BannerSlide = React.lazy(() => import('./BannerSlide'));
const $ = window.jQuery

function HomePage(props) {
  $(window).scrollTop('0');

  function HomeNextArrow(props) {
    const { onClick } = props;
    return (
      <img onClick={onClick} src={RightArrow} alt='right-arrow.png' className='img-fluid slick-arrow next' />
    );
  }

  function HomePrevArrow(props) {
    const { onClick } = props;
    return (
      <img onClick={onClick} src={LeftArrow} alt='left-arrow.png' className='img-fluid slick-arrow prev' />
    );
  }

  const sliderSetting = {
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 200000,
    infinite: false,
    arrows: false,
    prevArrow: <HomePrevArrow />,
    nextArrow: <HomeNextArrow />,
    dots: false,
    pauseOnHover: true,
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }]
  };

  function BannerNextArrow(props) {
    const { onClick } = props;
    return (
      <div onClick={onClick} className="sliderRightArrow"><img onClick={onClick} src={RightArrow} alt='right-arrow.png' className='img-fluid slick-arrow next' /></div>
    );
  }

  function BannerPrevArrow(props) {
    const { onClick } = props;
    return (
      <div onClick={onClick} className="sliderLeftArrow"><img onClick={onClick} src={LeftArrow} alt='left-arrow.png' className='img-fluid slick-arrow prev' /></div>
    );
  }
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 800px)' });
  const _settings = {
    initialSlide: isTabletOrMobile ? 1 : 0,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 200,
    arrows: (props.BannerImages.length > 3) ? true : false,
    prevArrow: <BannerPrevArrow />,
    nextArrow: <BannerNextArrow />,
    dots: true,
    pauseOnHover: true,
    infinite: true,
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        initialSlide: 1
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        initialSlide: 1
      }
    }]
  };

  const [videoGuideData, setVideoGuideData] = useState([])
  const [videoUrl, setVideoUrl] = useState('')
  const [isPlay, setIsPlay] = useState(false)
  const [ownToken, setOwnToken] = useState(localStorage.getItem('token'))

  useEffect(() => {
    fetchVideoGuide()
    props.dispatch(fetchBannerImagesData())
  }, [])

  async function fetchVideoGuide() {
    let res = await VideoGuideAPi();
    if (res.data.status === 0) {
      setVideoGuideData([])
    } else if (res.data.status === 1) {
      setVideoGuideData(res.data.data)
    }
  }

  useEffect(() => {
    setOwnToken(localStorage.getItem('token'))
  }, [props.token])

  const openSignUpTab = (param, value) => {
    $(`#${param}`).tab('show');
    props.dispatch(selectedUserType(value))
  }

  const getThumbnailYoutube = (url, quality) => {
    if (url) {
      var video_id, thumbnail, result;
      if (result = url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)) {
        video_id = result.pop();
      } else if (result = url.match(/youtu.be\/(.{11})/)) {
        video_id = result.pop();
      }

      if (video_id) {
        if (typeof quality === "undefined") {
          quality = 'high';
        }
        var quality_key = 'maxresdefault'; // Max quality
        if (quality === 'low') {
          quality_key = 'sddefault';
        } else if (quality === 'medium') {
          quality_key = 'mqdefault';
        } else if (quality === 'high') {
          quality_key = 'hqdefault';
        }

        var thumbnail = "http://img.youtube.com/vi/" + video_id + "/" + quality_key + ".jpg";
        return thumbnail;
      }
    }
    return false
  }

  const openVideoHandler = (url) => {
    setIsPlay(true)
    setVideoUrl(url)
    $(`#myYoutubeModal`).modal('show');
  }

  const isModalClose = () => {
    setIsPlay(false)
    setVideoUrl('')
    $(`#myYoutubeModal`).modal('hide');
  }

  return (
    <Suspense fallback={<Loader />}>
      {/* <BannerSlide /> */}
      <section className='banner-area'>
        {props.BannerImages.length > 0 ? <Slider {..._settings} className='artist-list' >
          {props.BannerImages.map((item, i) => {
            return <div className='artist' key={i}>
              <div className='image'>
                <img src={item.bannerImage} alt='Image 1' className='img-fluid' />
              </div>
              <div className='content'>
                <h2>{item.bannerTitle}</h2>
                {item.bannerSubTitle ? <h5>{item.bannerSubTitle}</h5> : ''}
                {item.bannerDescription ? <p>{item.bannerDescription}</p> : ''}
                {!ownToken ?
                  <button className='btn-default hvr-bounce-in'
                    data-toggle='modal' data-target='.bd-example-modal-lg' onClick={() => openSignUpTab('v-pills-signup-tab', i + 1)}>
                    <span className='icon'>
                      <img className='img-fluid' src={Logo} alt='Nexus Logo' />
                    </span>Signup Now</button> : ''}
              </div>
            </div>
          })}
        </Slider> :
          <Slider  {..._settings} className='artist-list'>
            <div className='artist'>
              <div className='image'>
                <img src={ArtistImage} alt='Image 1' className='img-fluid' />
              </div>
              <div className='content'>
                <h2>Artist</h2>
                {!ownToken ?
                  <button className='btn-default hvr-bounce-in'
                    data-toggle='modal' data-target='.bd-example-modal-lg' onClick={() => openSignUpTab('v-pills-signup-tab', 2)}>
                    <span className='icon'>
                      <img className='img-fluid' src={Logo} alt='Nexus Logo' />
                    </span>Signup Now</button> : ''}
              </div>
            </div>
            <div className='artist'>
              <div className='image'>
                <img src={InvestorImage} alt='Image 1' className='img-fluid' />
              </div>
              <div className='content'>
                <h2>Investor</h2>
                {!ownToken ?
                  <button className='btn-default hvr-bounce-in'
                    data-toggle='modal' data-target='.bd-example-modal-lg' onClick={() => openSignUpTab('v-pills-signup-tab', 1)}>
                    <span className='icon'>
                      <img className='img-fluid' src={Logo} alt='Nexus Logo' />
                    </span>Signup Now</button> : ''}
              </div>
            </div>
            <div className='artist'>
              <div className='image'>
                <img src={MusicianImage} alt='Image 1' className='img-fluid' />
              </div>
              <div className='content'>
                <h2>Musician</h2>
                {!ownToken ?
                  <button className='btn-default hvr-bounce-in'
                    data-toggle='modal' data-target='.bd-example-modal-lg' onClick={() => openSignUpTab('v-pills-signup-tab', 3)}>
                    <span className='icon'>
                      <img className='img-fluid' src={Logo} alt='Nexus Logo' />
                    </span>Signup Now</button> : ''}
              </div>
            </div>

          </Slider>}

      </section>
      <Ecommerce Image={ArtCommerce} Logo={Logo} />
      <CreatorInvestor Logo={Logo} />
      <AboutAndWhy Image={AboutImage} />

      <MostWatchedSlide />
      <GettingStarted Logo={Logo} Image={GetStart} isAuthenticated={props.token} />
      <RangeCheck Logo={Logo} />

      {videoGuideData && videoGuideData.length > 0 ? <section className="nexus-guide">
        <div className="container">
          <div className="section-heading">
            <h2>Nexus Video Guides</h2>
            <div className="slider-arrows">
              <button className="prev slider-arrow">
                <img src={LeftArrow} alt="" className="img-fluid" />
              </button>
              <button className="next slider-arrow">
                <img src={RightArrow} alt="" className="img-fluid" />
              </button>
            </div>
          </div>

          <Slider className="videos-slider" {...sliderSetting}>
            {videoGuideData && videoGuideData.length > 0 ? videoGuideData.map((item, i) => {
              return <Fragment key={i}>
                <div className="col-md-12" style={{ cursor: 'pointer' }}>
                  <div className="video">
                    <div className="image">
                      <img onClick={() => openVideoHandler(item.url)} src={item.url ? getThumbnailYoutube(item.url, 'medium') : getThumbnailYoutube('http://img.youtube.com/vi/JV9x2Y2tawY/maxresdefault.jpg', 'medium')} alt={item.title} className="img-fluid" />
                    </div>
                  </div>
                  <div className="video-title">
                    <p>{item.title}</p>
                  </div>
                </div>
              </Fragment>
            }) : ''}
          </Slider>
        </div>
      </section> : ''}

      <section className="blockchain">
        <div className="container">
          <div className="row">
            <div className="col-md-7 d-flex align-items-center">
              <div className="content">
                <div className="h1-title">It's on the Blockchain!</div>
                <div className="points">
                  <ul>
                    <li>Sign up and Mint your Art or Music NFTs – marking them as your own property. We offer free, gasless minting.</li>
                    <li> Enter your NFT Art into the marketplace and let others invest in your creations (or you as an artist)</li>
                    <li> Join the marketplace and invest in NFTs that speak to you</li>
                    <li> Subscribe and stay up to date with the latest in NFT news</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="image">
                <img src={BlockChainImage} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="modal fade" id="myYoutubeModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <button onClick={() => isModalClose()} type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="embed-responsive embed-responsive-16by9">
                <ReactPlayer playing={isPlay} controls={true} url={videoUrl} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  )
}
const mapStateToProps = state => {
  return {
    BannerImages: state.siteSettingReducer.bannerImages,
    token: state.userReducer.token,
    loading: state.userReducer.loading
  }
}

export default connect(mapStateToProps)(withRouter(HomePage));